import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { EditIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface EditButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	onClick: () => void;
}
export const EditButton: React.FC<EditButtonProps> = ({ ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<EditIcon />
			<div>{I18n.t("edit")}</div>
		</Container>
	);
};

const Container = styled.div`
	cursor: pointer;
	${({ theme }) => theme.textStyles.text};
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	border-radius: 12px;
	padding: 4px 12px;
	color: ${({ theme }) => theme.colors.secondary};
	${row(6, "flex-start", "center")}
	> svg {
		width: 15px;
		height: 15px;
		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
`;
